import { render } from "./stageDataView.vue?vue&type=template&id=0cc3ea4e&scoped=true"
import script from "./stageDataView.vue?vue&type=script&lang=js"
export * from "./stageDataView.vue?vue&type=script&lang=js"

import "./stageDataView.vue?vue&type=style&index=0&id=0cc3ea4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc3ea4e"]])

export default __exports__